/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface KycDocumentEventTimelinePayload
 */
export interface KycDocumentEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof KycDocumentEventTimelinePayload
     */
    kycDocumentId: string;
    /**
     * 
     * @type {string}
     * @memberof KycDocumentEventTimelinePayload
     */
    kycDocumentType: string;
    /**
     * 
     * @type {string}
     * @memberof KycDocumentEventTimelinePayload
     */
    refusalReason?: string;
}

/**
 * Check if a given object implements the KycDocumentEventTimelinePayload interface.
 */
export function instanceOfKycDocumentEventTimelinePayload(value: object): value is KycDocumentEventTimelinePayload {
    if (!('kycDocumentId' in value) || value['kycDocumentId'] === undefined) return false;
    if (!('kycDocumentType' in value) || value['kycDocumentType'] === undefined) return false;
    return true;
}

export function KycDocumentEventTimelinePayloadFromJSON(json: any): KycDocumentEventTimelinePayload {
    return KycDocumentEventTimelinePayloadFromJSONTyped(json, false);
}

export function KycDocumentEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): KycDocumentEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'kycDocumentId': json['kycDocumentId'],
        'kycDocumentType': json['kycDocumentType'],
        'refusalReason': json['refusalReason'] == null ? undefined : json['refusalReason'],
    };
}

export function KycDocumentEventTimelinePayloadToJSON(value?: KycDocumentEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'kycDocumentId': value['kycDocumentId'],
        'kycDocumentType': value['kycDocumentType'],
        'refusalReason': value['refusalReason'],
    };
}

